import { useDispatch } from "react-redux";

import { closeModal } from "libs/modals";

import { UserSheet } from "../user-sheet";
import { EDIT_USER_MODAL } from "../../UserModals";
import type { CollaborationPostStatus } from "features/user";

export type { UserSheetMode } from "../user-sheet";

/**
 * Preserved for external consumers (`pages/home/components/modules/InsightsStatistic.tsx`,
 * `api/insightsApi.ts`). The sheet-based UserSheet uses the same literal set.
 */
export type ReportBuilderPermission =
  "full-access" | "no-access" | "download-only";

/**
 * Re-exported for `AllowPostStatusList.tsx` which imports it from this file.
 */
export type Status = CollaborationPostStatus & { selected: boolean };

interface EditUserModalProps {
  userInfo: {
    _id?: string;
    email: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    profileImage?: string;
    status?: string;
  };
}

/**
 * Thin wrapper so Redux-dispatched `openModal({type: EDIT_USER_MODAL})`
 * entry points keep working — they render the new right-hand
 * {@link UserSheet} in edit mode.
 */
export const EditUserModal = ({
  userInfo,
}: EditUserModalProps): JSX.Element => {
  const dispatch = useDispatch();
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      dispatch(closeModal({ type: EDIT_USER_MODAL }));
    }
  };
  return (
    <UserSheet
      open
      mode="edit"
      userInfo={userInfo}
      onOpenChange={handleOpenChange}
    />
  );
};
